import React, { PropsWithChildren, useContext } from "react";
import { TooltipContext } from "../types/tooltip.context";
import { StyledTooltipTitle } from "./tooltip-title.styles";

export const TooltipTitle = (props: PropsWithChildren<any>) => {
  const context = useContext(TooltipContext);
  return <StyledTooltipTitle colour={context.colour}>{props.children}</StyledTooltipTitle>;
};
